import React from "react";
import {
  Box,
  Button,
  List,
  ListItem,
  Typography,
  TextField,
} from "@mui/material";

const QuantityEntryStep = ({
  selectedProduct,
  selectedAreaIds,
  areaCounts,
  quantityByAreaId,
  onQuantityChange,
  onSave,
  canSave,
  saveLabel = "Add Products To Count",
}) => {
  const handleInputChange = (areaCountId, value) => {
    const sanitized = value.replace(/[^0-9.,]/g, "");
    onQuantityChange(areaCountId, sanitized);
  };

  const areaById = new Map(areaCounts.map((a) => [a.id, a]));

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          {selectedProduct?.productName || selectedProduct?.displayName}
        </Typography>
        {selectedProduct?.formatName ? (
          <Typography variant="body2" color="text.secondary">
            {selectedProduct.formatName}
          </Typography>
        ) : null}
      </Box>

      <Box
        sx={{
          maxHeight: 400,
          overflow: "auto",
          border: "1px solid",
          borderColor: (theme) => theme.palette.terrain[300],
          borderRadius: 1,
          marginBottom: 4,
        }}
      >
        <List disablePadding>
          {selectedAreaIds.map((areaCountId) => {
            const area = areaById.get(areaCountId);
            const value = quantityByAreaId[areaCountId];
            return (
              <ListItem
                key={areaCountId}
                sx={{
                  backgroundColor: (theme) => theme.palette.terrain[50],
                  borderBottom: "1px solid",
                  borderColor: (theme) => theme.palette.terrain[300],
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 2,
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {area?.name || "Area"}
                  </Typography>
                </Box>
                <Box sx={{ flexShrink: 0, minWidth: 100 }}>
                  <TextField
                    size="small"
                    placeholder="0.00"
                    value={value || ""}
                    onChange={(e) =>
                      handleInputChange(areaCountId, e.target.value)
                    }
                    fullWidth
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      "& .MuiOutlinedInput-root": {
                        background: (theme) => theme.palette.pure.white,
                      },
                      "& input": { textAlign: "center" },
                      "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                        {
                          display: "none",
                        },
                    }}
                    error={value === undefined || value === ""}
                  />
                </Box>
              </ListItem>
            );
          })}
        </List>
      </Box>

      <Box sx={{ marginTop: 4 }}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!canSave}
          fullWidth
          sx={{ height: 48 }}
        >
          {saveLabel}
        </Button>
      </Box>
    </>
  );
};

export default QuantityEntryStep;
